(function () {
function $291aef245a3a4426$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $291aef245a3a4426$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $291aef245a3a4426$var$passiveTestOptions = {
        get passive () {
            $291aef245a3a4426$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $291aef245a3a4426$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $291aef245a3a4426$var$passiveTestOptions);
}
var $291aef245a3a4426$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $291aef245a3a4426$var$locks = [];
var $291aef245a3a4426$var$documentListenerAdded = false;
var $291aef245a3a4426$var$initialClientY = -1;
var $291aef245a3a4426$var$previousBodyOverflowSetting = void 0;
var $291aef245a3a4426$var$previousBodyPosition = void 0;
var $291aef245a3a4426$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $291aef245a3a4426$var$allowTouchMove = function allowTouchMove(el) {
    return $291aef245a3a4426$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $291aef245a3a4426$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($291aef245a3a4426$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $291aef245a3a4426$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($291aef245a3a4426$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
            $291aef245a3a4426$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($291aef245a3a4426$var$previousBodyOverflowSetting === undefined) {
        $291aef245a3a4426$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $291aef245a3a4426$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($291aef245a3a4426$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $291aef245a3a4426$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $291aef245a3a4426$var$previousBodyPaddingRight = undefined;
    }
    if ($291aef245a3a4426$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $291aef245a3a4426$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $291aef245a3a4426$var$previousBodyOverflowSetting = undefined;
    }
};
var $291aef245a3a4426$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($291aef245a3a4426$var$previousBodyPosition === undefined) {
            $291aef245a3a4426$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = "fixed";
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $291aef245a3a4426$var$restorePositionSetting = function restorePositionSetting() {
    if ($291aef245a3a4426$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $291aef245a3a4426$var$previousBodyPosition.position;
        document.body.style.top = $291aef245a3a4426$var$previousBodyPosition.top;
        document.body.style.left = $291aef245a3a4426$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $291aef245a3a4426$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $291aef245a3a4426$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $291aef245a3a4426$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $291aef245a3a4426$var$initialClientY;
    if ($291aef245a3a4426$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $291aef245a3a4426$var$preventDefault(event);
    if ($291aef245a3a4426$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $291aef245a3a4426$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $291aef245a3a4426$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($291aef245a3a4426$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $291aef245a3a4426$var$locks = [].concat($291aef245a3a4426$var$_toConsumableArray($291aef245a3a4426$var$locks), [
        lock
    ]);
    if ($291aef245a3a4426$var$isIosDevice) $291aef245a3a4426$var$setPositionFixed();
    else $291aef245a3a4426$var$setOverflowHidden(options);
    if ($291aef245a3a4426$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $291aef245a3a4426$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $291aef245a3a4426$var$handleScroll(event, targetElement);
        };
        if (!$291aef245a3a4426$var$documentListenerAdded) {
            document.addEventListener("touchmove", $291aef245a3a4426$var$preventDefault, $291aef245a3a4426$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $291aef245a3a4426$var$documentListenerAdded = true;
        }
    }
};
var $291aef245a3a4426$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($291aef245a3a4426$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $291aef245a3a4426$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($291aef245a3a4426$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $291aef245a3a4426$var$preventDefault, $291aef245a3a4426$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $291aef245a3a4426$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $291aef245a3a4426$var$initialClientY = -1;
    }
    if ($291aef245a3a4426$var$isIosDevice) $291aef245a3a4426$var$restorePositionSetting();
    else $291aef245a3a4426$var$restoreOverflowSetting();
    $291aef245a3a4426$var$locks = [];
};
var $291aef245a3a4426$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $291aef245a3a4426$var$locks = $291aef245a3a4426$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($291aef245a3a4426$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($291aef245a3a4426$var$documentListenerAdded && $291aef245a3a4426$var$locks.length === 0) {
            document.removeEventListener("touchmove", $291aef245a3a4426$var$preventDefault, $291aef245a3a4426$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $291aef245a3a4426$var$documentListenerAdded = false;
        }
    }
    if ($291aef245a3a4426$var$isIosDevice) $291aef245a3a4426$var$restorePositionSetting();
    else $291aef245a3a4426$var$restoreOverflowSetting();
};


jQuery(document).ready(function($) {
    "use strict";
    function getFocusable($el) {
        return $el.find("a, button, input, textarea, select, details");
    }
    /**
	 * Desktop menu
	 */ $(".page-header__nav .menu-item-has-children").each(function() {
        var $menuItem = $(this);
        var $link = $menuItem.children("a").first();
        var timer;
        var $submenu = $menuItem.children("ul").first();
        var openMenu = function() {
            $menuItem.addClass("expanded");
            getFocusable($submenu).attr("tabindex", "0");
            $submenu.attr("aria-hidden", "false");
        };
        var closeMenu = function() {
            $menuItem.removeClass("expanded");
            getFocusable($submenu).attr("tabindex", "-1");
            $submenu.attr("aria-hidden", "true");
        };
        closeMenu();
        $menuItem.on("mouseenter", function() {
            window.clearTimeout(timer);
            timer = window.setTimeout(openMenu, 250);
        });
        $menuItem.on("mouseleave", function() {
            window.clearTimeout(timer);
            timer = window.setTimeout(closeMenu, 250);
        });
        $link.on("keydown", function(event) {
            if (event.key === "Enter") {
                event.preventDefault();
                openMenu();
                getFocusable($menuItem).first().focus();
            }
        });
        $menuItem.on("keydown", function(event) {
            if (event.key === "Escape") {
                event.preventDefault();
                $link.focus();
                closeMenu();
            }
        });
        $(document).on("keyup", function(event) {
            if (event.key === "Tab" && !$.contains($menuItem[0], event.target)) closeMenu();
        });
    });
    /**
	 * Foldout navigation
	 */ $(".foldout").each(function() {
        var $foldout = $(this);
        var $button = $foldout.find(".foldout__button");
        var $menu = $foldout.find(".foldout__menu");
        var expanded = $foldout.hasClass("expanded");
        if ($button.length === 0 || $menu.length === 0) return;
        var open = function() {
            $foldout.addClass("expanded");
            getFocusable($menu).attr("tabindex", "0");
            $menu.attr("aria-hidden", "false");
            expanded = true;
        };
        var close = function() {
            $foldout.removeClass("expanded");
            getFocusable($menu).attr("tabindex", "-1");
            $menu.attr("aria-hidden", "true");
            expanded = false;
        };
        var toggle = function() {
            if (expanded) close();
            else open();
        };
        close();
        $button.on("click", function() {
            toggle();
        });
        $foldout.on("keydown", function(event) {
            if (event.key === "Escape" && expanded) {
                event.preventDefault();
                event.stopPropagation();
                $button.focus();
                close();
            }
        });
        $(document).on("keydown", function(event) {
            if (event.key === "Escape" && expanded) close();
        });
        $(document).on("focusin click", function(event) {
            if (expanded && !$.contains($foldout[0], event.target)) close();
        });
    });
    /**
	 * Modals
	 */ $("[data-modal]").each(function() {
        var $modal = $(this);
        var $window = $modal.find(".modal__window");
        var id = $modal.attr("data-modal");
        var $openButtons = $('[data-open-modal="' + id + '"]');
        var $closeButtons = $('[data-close-modal="' + id + '"]');
        var $buttonThatOpened;
        var open = false;
        var openModal = function() {
            $modal.addClass("open");
            $modal.show();
            getFocusable($window).first().focus();
            (0, $291aef245a3a4426$export$24fdf68abf432c44)($modal[0]);
            open = true;
        };
        var closeModal = function() {
            $modal.hide();
            $modal.removeClass("open");
            (0, $291aef245a3a4426$export$e5d0524c3725571e)($modal[0]);
            if ($buttonThatOpened && $buttonThatOpened.length > 0) $buttonThatOpened.first().focus();
            open = false;
        };
        closeModal();
        $openButtons.on("click", function() {
            $buttonThatOpened = $(this);
            openModal();
        });
        $closeButtons.on("click", function() {
            closeModal();
        });
        $modal.on("click", function(event) {
            if (open && event.target === $modal[0]) closeModal();
        });
        $(document).on("keyup", function(event) {
            if (open && event.key === "Tab" && !$.contains($window[0], event.target)) {
                if (event.shiftKey) getFocusable($window).last().focus();
                else getFocusable($window).first().focus();
            }
        });
        $(document).on("keydown", function(event) {
            if (event.key === "Escape" && open) closeModal();
        });
    });
    /**
	 * Event tracking
	 */ function trackEvent(category, action, label) {
        if (!label) label = "";
        if ("ga" in window) ga("send", "event", category, action, label);
        if ("fbq" in window) fbq("trackCustom", category + action, {
            label: label
        });
    }
    $(".bottom-bar bottom-bar__button").on("click", function() {
        trackEvent("BottomBar", "Click", travelnews_ajax_posts.post_slug);
    });
    $(".page-header .subscription-status__button--premium").on("click", function() {
        trackEvent("SubscriptionStatus", "Click");
    });
    $(".paywall .premium-button").on("click", function() {
        trackEvent("Paywall", "Click", travelnews_ajax_posts.post_slug);
    });
    $("[data-package-click]").on("click", function() {
        var pkgLabel = $(this).attr("data-package-click");
        trackEvent("Packages", "Click", pkgLabel);
    });
    /* Menu responsive */ var $toggle_icon = $("#nav-toggler");
    var $menu = $("#mobile-nav");
    $toggle_icon.on("click", function(e) {
        e.preventDefault();
        $toggle_icon.toggleClass("active");
        $menu.animate({
            height: "toggle"
        }, 350);
    });
    //mobile menu dropdown
    $("#mobile_menu .menu-item-has-children > a").on("click", function(event) {
        event.preventDefault();
        if ($(this).parents(".menu-item-has-children").hasClass("active")) $(this).parents(".menu-item-has-children").removeClass("active");
        else $(this).parents(".menu-item-has-children").addClass("active");
    });
    //comments toggle
    var commentsOpen = false;
    $(".comments-open").on("click", function() {
        var $btn = $(this);
        $(".comments-toggle-wrapper").slideToggle(250, function() {
            commentsOpen = !commentsOpen;
            $btn.text(commentsOpen ? travelnews_ajax_posts.close : travelnews_ajax_posts.open);
        });
    });
    //Raporter page scripts
    const sortListItem = $(".sort-list--item");
    const sortBlockTitle = $(".sort-block--title");
    const filterListItem = $(".filter-list .filter-list-item");
    var tnFilters = function() {
        let catFilters = [];
        let sortBy = $(".sort-list--item.active").data("sort");
        let searchVal = $("#input-filter").val();
        $(".filter-list .filter-list-item.active").each(function() {
            catFilters.push($(this).data("filter"));
        });
        let statusEl = $(".loading-status");
        let loadPosts = $("#container-async");
        let data = {
            "action": "tn_filter",
            "query": travelnews_ajax_posts.posts,
            "page": travelnews_ajax_posts.current_page,
            "terms": catFilters,
            "order": sortBy,
            "search": searchVal,
            "offset": travelnews_ajax_posts.offset,
            "max_page": travelnews_ajax_posts.max_page
        };
        $.ajax({
            url: travelnews_ajax_posts.ajaxurl,
            data: data,
            type: "POST",
            beforeSend: function(xhr, textStatus) {
                statusEl.show(); // show preloader
            },
            success: function(data) {
                if (data) {
                    // console.log(data);
                    loadPosts.html(data);
                    statusEl.hide();
                // console.log('da nax');
                // $('.page-numbers').on('click', function(e){
                // 	e.preventDefault();
                // 	tnFilters();
                // 	console.log('cxui');
                // });
                // you can also fire the "post-load" event here if you use a plugin that requires it
                // $( document.body ).trigger( 'post-load' );
                } else statusEl.remove(); // if no data, remove the button as well
            },
            error: function(textStatus) {
                console.log("Ooops something wrong");
            }
        });
    };
    tnFilters();
    //Sort title click handler
    sortBlockTitle.on("click", function(e) {
        $(".overlay").show();
        let sortTitle = $(this);
        let sortList = $(this).closest(".sort-block").find(".sort-list");
        sortList = sortList.hasClass("active") ? sortList.removeClass("active") : sortList.addClass("active");
        sortTitle = sortTitle.hasClass("active") ? sortTitle.removeClass("active") : sortTitle.addClass("active");
        e.stopPropagation();
    });
    //Sort item click handler
    sortListItem.on("click", function(e) {
        let sortTitleText = $(this).closest(".sort-block").find(".sort-text");
        let currentListItem = $(this);
        sortListItem.removeClass("active");
        currentListItem = currentListItem.hasClass("active") ? currentListItem.removeClass("active") : currentListItem.addClass("active");
        sortTitleText.text(currentListItem.text());
        $(".sort-list").removeClass("active");
        $(".sort-block--title").removeClass("active");
        e.stopPropagation();
        tnFilters();
    });
    filterListItem.on("click", function() {
        $(this).hasClass("active") ? $(this).removeClass("active") : $(this).addClass("active");
        if ($(this).data("filter") != "all") $('[data-filter="all"]').removeClass("active");
        tnFilters();
    });
    $("#input-filter").keyup(function() {
        if ($(this).val().length > 3) tnFilters();
    });
    /**
	 * Bottom bar
	 */ if (document.cookie.indexOf("premium_dismissed=true") !== -1) $(".bottom-bar").remove();
    $("[data-bottom-bar-dismiss]").on("click", function() {
        var timeout = $(this).attr("data-bottom-bar-dismiss");
        document.cookie = "premium_dismissed=true; path=/; max-age=" + timeout;
        var $bottomBar = $(this).closest(".bottom-bar");
        $bottomBar.on("animationend", function() {
            $bottomBar.remove();
        });
        $bottomBar.removeClass("bottom-bar--animate-in");
        $bottomBar.addClass("bottom-bar--animate-out");
    });
    /**
	 * Paywall
	 */ $(".paywall.paywall--expandable-list").each(function() {
        var $paywall = $(this);
        var $list = $paywall.find("ul");
        var $toggleWrap = $list.prev("p");
        $list.addClass("paywall__expand-list");
        var $toggle = $('<button class="invisible-button"></button>');
        $toggle.addClass("paywall__expand-button");
        if (window.matchMedia && matchMedia("(min-width: 576px)").matches) {
            $toggle.addClass("paywall__expand-button--expanded");
            $list.addClass("paywall__expand-list--expanded");
        }
        $toggle.text($toggleWrap.text());
        $toggle.on("click", function() {
            $toggle.toggleClass("paywall__expand-button--expanded");
            $list.toggleClass("paywall__expand-list--expanded");
        });
        $toggleWrap.empty();
        $toggleWrap.append($toggle);
    });
    // $('.page-numbers').on('click', function(event) {
    // 	event.preventDefault();
    // 	let data = {
    // 		'action': 'tn_filter',
    // 		'query': travelnews_ajax_posts.posts,
    // 		'page': travelnews_ajax_posts.current_page,
    // 		'offset': travelnews_ajax_posts.offset,
    // 	}
    // 	$.ajax({
    // 		url : travelnews_ajax_posts.ajaxurl, // AJAX handler
    // 		data : data,
    // 		type : 'POST',
    // 		beforeSend : function ( xhr, textStatus ) {
    // 			statusEl.show(); // show preloader
    // 		},
    // 		success : function( data ){
    // 			if( data ) { 
    // 				// console.log(data);
    // 				loadPosts.html(data);
    // 				statusEl.hide();
    // 				travelnews_ajax_posts.current_page = parseInt($(this).text());
    // 				travelnews_ajax_posts.offset = parseInt(travelnews_ajax_posts.offset) + 9;
    // 				// you can also fire the "post-load" event here if you use a plugin that requires it
    // 				// $( document.body ).trigger( 'post-load' );
    // 			} else {
    // 				statusEl.remove(); // if no data, remove the button as well
    // 			}
    // 		},
    // 		error: function (textStatus) {
    //      	console.log('Ooops something wrong');
    //      }
    // 	});
    // });
    //click blocks handler
    $(document).on("click", function(e) {
        //Close sort list if outside sort-block
        if ($(e.target).is(".sort-block") === false) {
            $(".sort-list").removeClass("active");
            $(".sort-block--title").removeClass("active");
        }
    });
    /* Job announcements scroller */ $(window).on("load", function() {
        $(".items").slick({
            slidesToShow: 3,
            variableWidth: true,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: false,
            dots: false,
            infinite: true,
            rows: 1,
            cssEase: "ease-in",
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $(".owl-demo .owl-item img").each(function() {
            $(this).imagefit(true);
        });
        $(".owl-demo").owlCarousel({
            pagination: false,
            dots: false,
            items: 1,
            navigationText: [
                "f\xf6re",
                "n\xe4sta"
            ],
            autoPlay: false,
            itemsDesktop: [
                1199,
                1
            ],
            itemsDesktopSmall: [
                979,
                1
            ],
            itemsMobile: [
                479,
                1
            ],
            navigation: true,
            singleItem: true,
            afterInit: function() {
                showImages();
            }
        });
    });
    function showImages() {
        $(".owl-demo .owl-item .item").addClass("visible");
    }
    $.fn.imagefit = function(contain) {
        this.each(function() {
            var $this = $(this), $wrapper = $this.parent(), wrapper_width = $wrapper.width(), wrapper_height = $wrapper.height(), wrapper_ratio, image_ratio;
            image_ratio = $this.width() / $this.height();
            wrapper_ratio = wrapper_width / wrapper_height;
            var ratio_cond = wrapper_ratio > image_ratio;
            if (contain) ratio_cond = !ratio_cond;
            if (ratio_cond) $wrapper.css({
                "background": "url(" + $this.get(0).src + ")",
                "background-size": "100% auto",
                "background-position": "0px 50%",
                "background-repeat": "no-repeat"
            });
            else $wrapper.css({
                "background": "url(" + $this.get(0).src + ")",
                "background-size": "auto 100%",
                "background-position": "50% 0px",
                "background-repeat": "no-repeat"
            });
            $this.remove();
        });
        return this;
    };
    /* Read More Single Article Navigation */ var $row_container = $("#read_more_articles .row");
    $row_container.slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        rows: 2,
        variableWidth: false,
        autoplay: false,
        arrows: true,
        appendArrows: $(".read_more_navigation"),
        prevArrow: '<span class="previous"></span>',
        nextArrow: '<span class="next"></span>',
        dots: false,
        infinite: false,
        cssEase: "ease-in",
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    rows: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 350,
                settings: {
                    rows: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    /* Job article +/- toggle*/ var $container_jobs, $single_job;
    $(document).on("click", ".job_loader", function() {
        var $this = $(this);
        $container_jobs = $this.parents(".jobs_announcement");
        $single_job = $container_jobs.find(".job_announcement");
        $single_job.each(function(e) {
            console.log(e);
            var $single_this = $(this);
            if ($single_this.hasClass("hidden")) {
                $single_this.removeClass("hidden").addClass("visible");
                $this.addClass("expanded");
            } else if ($single_this.hasClass("visible")) {
                $single_this.removeClass("visible").addClass("hidden");
                $this.removeClass("expanded");
            }
            if ($single_this.hasClass("fifth")) $single_this.toggleClass("line");
        });
    });
    /* AJAX add job articles */ /*Jobs*/ //   var $job_loader     = $('.job_loader');
    //   var $container_jobs;
    //   var order_by_job,
    // order_job,
    // post_id,
    // ppp_job,
    // ids;
    //   $(document).on('click', '.job_loader', function () {
    //   	var $this       = $(this);
    // $container_jobs = $this.parents('.jobs_announcement');
    //   	order_by_job    = $this.data('orderby');
    // order_job       = $this.data('order');
    // ppp_job         = $this.data('ppp');
    // ids         	= $container_jobs.find('.job_posts_ids').attr('data-ids');
    //       load_job_posts();
    //   });
    //   function load_job_posts() {
    //       if (!($job_loader.hasClass('job_posts_loading') || $job_loader.hasClass('no_more_job_postings'))) {
    //           var str = '&ppp=' + ppp_job + '&order_by=' + order_by_job + '&order=' + order_job + '&ids=' + ids + '&action=travelnews_add_job_posts';
    //           $.ajax({
    //               type: 'POST',
    //               dataType   : 'html',
    //               url: travelnews_ajax_posts.ajaxurl,
    //               data: str,
    //               success: function (data) {
    //               	var $data = $(data);
    //                   if ($data.length) {
    //                   	$data.each(function(){
    //                   		post_id = $(this).data('post_id');
    //                   		ids += ','+post_id;
    //                   	});
    //                       var $newElements = $data.css({ opacity: 0 });
    //                       $container_jobs.append($newElements);
    //                       $container_jobs.imagesLoaded(function () {
    //                           $newElements.animate({ opacity: 1 });
    //                       });
    //                       $job_loader.removeClass('job_posts_loading');
    //                   } else {
    //                       $job_loader.addClass('no_more_job_postings');
    //                       $container_jobs.append('<div class="job_announcement"><p>' + travelnews_ajax_posts.noposts + '</p></div>' );
    //                   }
    //               },
    //               beforeSend : function () {
    //                   $job_loader.addClass('job_posts_loading');
    //               },
    //               error : function (jqXHR, textStatus, errorThrown) {
    //                   $job_loader.html(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
    //               },
    //               complete : function () {
    //                   $job_loader.removeClass('job_posts_loading');
    //                   $container_jobs.find('.job_posts_ids').attr('data-ids', '').attr('data-ids', ids);
    //               }
    //           });
    //       }
    //       return false;
    //   }
    /*Recent posts*/ var $recent_post_loader = $(".recent_post_loader");
    var $container_recent;
    var recent_order_by, recent_order, cat_recent, recent_post_id, recent_ids, ppp_recent;
    $(document).on("click", ".recent_post_loader", function() {
        var $this = $(this);
        $container_recent = $this.parents(".recent_posts");
        recent_order_by = $this.data("orderby");
        recent_order = $this.data("order");
        cat_recent = $this.data("cat");
        ppp_recent = $this.data("ppp");
        recent_ids = $container_recent.find(".posts_ids").attr("data-ids");
        load_recent_posts();
    });
    function load_recent_posts() {
        if (!($recent_post_loader.hasClass("recent_posts_loading") || $recent_post_loader.hasClass("no_more_recent_posts"))) {
            var str = "&ppp=" + ppp_recent + "&cat=" + cat_recent + "&order_by=" + recent_order_by + "&order=" + recent_order + "&ids=" + recent_ids + "&action=travelnews_add_recent_posts";
            $.ajax({
                type: "POST",
                dataType: "html",
                url: travelnews_ajax_posts.ajaxurl,
                data: str,
                success: function(data) {
                    var $data = $(data);
                    if ($data.length) {
                        var $newElements = $data.css({
                            opacity: 0
                        });
                        $data.each(function() {
                            recent_post_id = $(this).data("post_id");
                            recent_ids += "," + recent_post_id;
                        });
                        $container_recent.append($newElements);
                        $container_recent.imagesLoaded(function() {
                            $newElements.animate({
                                opacity: 1
                            });
                        });
                        $recent_post_loader.removeClass("recent_posts_loading");
                    } else {
                        $recent_post_loader.addClass("no_more_recent_posts");
                        $container_recent.append('<div class="recent_post"><p>' + travelnews_ajax_posts.noposts + "</p></div>");
                    }
                },
                beforeSend: function() {
                    $recent_post_loader.addClass("recent_posts_loading");
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    $recent_post_loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
                },
                complete: function() {
                    $recent_post_loader.removeClass("recent_posts_loading");
                    $container_recent.find(".posts_ids").attr("data-ids", "").attr("data-ids", recent_ids);
                }
            });
        }
        return false;
    }
    /* Google */ // $("#comment-submit").on('click', function(e){
    // 	var data_2;
    // 	$.ajax({
    // 		type: 'POST',
    // 		action: 'google_recaptcha',
    // 		data: $('#commentform').serialize(),
    //            url: travelnews_ajax_posts.ajaxurl,
    //            async: true,
    // 		success: function(data) {
    // 			if(data.nocaptcha === "true"){
    // 				data_2=1;
    // 			} else if(data.spam === "true") {
    // 				data_2=1;
    // 			} else {
    // 				data_2=0;
    // 			}
    // 		},
    // 		error : function (jqXHR, textStatus, errorThrown) {
    //                console.log(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
    //            }
    // 	});
    // 	if( data_2 !== 0 ){
    // 		e.preventDefault();
    // 		if(data_2 == 1){
    // 			$('.form-submit').after('<p class="captcha_alert">'+travelnews_ajax_posts.google_captcha_check+'</p>');
    // 				setTimeout(function() { $(".captcha_alert").fadeOut(); }, 4000);
    // 		} else {
    // 			$('.form-submit').after('<p class="captcha_alert">'+travelnews_ajax_posts.google_captcha_check+'</p>');
    // 				setTimeout(function() { $(".captcha_alert").fadeOut(); }, 4000);
    // 		}
    // 	} else {
    // 		$("#commentform").submit();
    // 	}
    // });
    /* Resize */ $(window).on("resize", function() {
    // if ( $(window).width() < 820 ) {
    //       	$('#header-buttons-container').addClass('hide-mobile');
    // } else if($(window).width() > 820) {
    // 	$('#header-buttons-container').removeClass('hide-mobile');
    // }
    });
    $("#search-container").on("click", function() {
        $(window).off("resize");
    });
    /* Newsletter popup */ $("[data-newsletter-popup]").each(function() {
        var $popup = $(this);
        var $dismiss = $popup.find('[data-newsletter-popup-action="dismiss"]');
        var $form = $popup.find("form");
        var setCookie = function() {
            document.cookie = "newsletter_dismissed=;max-age=2592000;path=/";
        };
        $dismiss.on("click", function() {
            $popup.addClass("newsletter-popup--hidden");
            setCookie();
        });
        $form.on("submit", function() {
            setCookie();
        });
        var newsletterWasDismissed = document.cookie.indexOf("newsletter_dismissed") !== -1;
        var openedFromNewsletter = location.search.indexOf("utm_medium=email") !== -1;
        var bottomBarVisible = $(".bottom-bar").length > 0;
        if (!newsletterWasDismissed && !openedFromNewsletter && !bottomBarVisible) $popup.removeClass("newsletter-popup--hidden");
    });
});

})();
//# sourceMappingURL=scripts.js.map
